module.exports = "/_next/static/images/e291f247df2213bbf4b6829efa38a0ee-phone-and-card@sm-2x.jpg";